import { Routes, Route, Navigate } from "react-router-dom";
import AuthRoutes from "../../auth/router/AuthRoutes";
import { useContext } from "react";
import { MainContext } from "../context/MainContextProvider";
import AuthenticatedRoutes from "./AuthenticatedRoutes";
import ReactGA from "react-ga4";
import { RoutesTracker } from "../../analytics/components/RoutesTracker";


ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID);



export default function MainRouter() {
  const {
    user,
    userIsLogged,
    // , user
  } = useContext(MainContext);

  return (
    <>
      <RoutesTracker />
      <Routes>
        <>
          {userIsLogged && !user?.passwordReseted ? (
            <Route path="/*" element={<AuthenticatedRoutes />} />
          ) : (
            <>
              <Route
                path="/*"
                element={
                  <Navigate
                    to={user?.passwordReseted ? "/login/nova-senha" : "/login"}
                  />
                }
              />
              <Route path="/login/*" element={<AuthRoutes />} />
            </>
          )}
        </>
      </Routes>
    </>
  );
}
